const moduleName = 'logo';

module.exports = () => {

	Array.from(document.querySelectorAll('.js-logo')).forEach((self) => {
		if (self.dataset[moduleName + 'Init'] === 'true') return;
		self.dataset[moduleName + 'Init'] = true;

		const logo = self;

		logo.addEventListener('mouseenter', () => {
			if (!logo.classList.contains('_animated')) {
				logo.classList.add('_animated');

				setTimeout(() => {
					logo.classList.remove('_animated');
				}, 1000);
			}
		});
	});
	
};